// extracted by mini-css-extract-plugin
export default {"PeopleVoted":"GamePickEm-module__PeopleVoted__qkwpS"};